import { SET_LAB_DATA, SET_LAB_LOADING } from '../../Type'

export const setLabData = (data)=>({
    type:SET_LAB_DATA,
    setData:data
})
export const setLabLoading= (data)=>({
    type:SET_LAB_LOADING,
    setLoading:data
})